import type { SportsEventInfoState } from './types';

export const defaultState: SportsEventInfoState = {
  isLoading: false,
  hasPreloaded: false,
  hasTeamStats: false
};
